var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner"},[_c('div',{staticClass:"partner-content"},_vm._l((_vm.partners.slice(0, 8)),function(item,index){return _c('div',{key:index,staticClass:"partner-item"},[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":item.picture},on:{"click":function($event){return _vm.openLink(item.url)}}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }